import { DESIGN_THEME } from "./semantics.js";
export const drawSpreadsheetHeader = ({ ctx, rect, column, theme, isHovered, hasSelectedCell, resolveColor, }) => {
    ctx.save();
    ctx.fillStyle = isHovered
        ? theme.bgHeaderHovered
        : hasSelectedCell
            ? theme.bgHeaderHasFocus
            : resolveColor(DESIGN_THEME.bgHeader ?? "");
    ctx.fillRect(rect.x, rect.y, rect.width, rect.height);
    ctx.fillStyle = theme.textHeader;
    ctx.font = `${theme.headerFontStyle} ${theme.fontFamily}`;
    ctx.textAlign = "center";
    ctx.textBaseline = "middle";
    ctx.fillText(column.title, rect.x + rect.width / 2, rect.y + rect.height / 2);
    ctx.fillStyle = theme.borderColor;
    ctx.fillRect(rect.x + rect.width - 1, rect.y, 1, rect.height);
    ctx.restore();
};
//# sourceMappingURL=spreadsheetHeader.js.map